import { render, staticRenderFns } from "./PrestacaoDeConta.vue?vue&type=template&id=8d2e95da&"
import script from "./PrestacaoDeConta.vue?vue&type=script&lang=js&"
export * from "./PrestacaoDeConta.vue?vue&type=script&lang=js&"
import style0 from "./PrestacaoDeConta.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "PrestacaoDeConta.vue"
export default component.exports